/**
 * Positionnement du sidebar sticky
 * @author Sandrine M'zé
 * par artwaï pour artwaï
 *
 */

const sidebar = {

    element: [],
    parent: [],
    offset: 70,

    init() {
        if (window.innerWidth > 1280) {
            sidebar.element = document.querySelector('.sidebar-details');
            sidebar.parent = document.querySelector('.sidebar');
            sidebar.parent.style.marginTop = -sidebar.element.offsetHeight - 70 + 'px';
        }
    },

}

document.addEventListener('DOMContentLoaded', sidebar.init);